import {API_URL, API_URL_NEW,ORDER_API_URL} from '../constants'
import { apiFetch } from './client';
import {setNotifications} from "../store/slices/notifications";


export const getAllOrdersTime = async (queryParams) => {
    console.log('queryParams',queryParams);
    const res = await apiFetch(`${API_URL_NEW}/admin-api/shop/production/production-time`,{
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    return await res.json();
};

export const updateOrdersTime = async ({data,  onSuccess}) => {
    const res = await apiFetch(`${API_URL_NEW}/admin-api/shop/production/production-time`,{
        method: "POST",
        // mode: "no-cors", // no-cors, *cors, same-origin
        headers: {
            "Content-Type": "application/json",
            // 'Content-Type': 'application/x-www-form-urlencoded',
            // 'Access-Control-Allow-Origin': '*',
        },
        body:JSON.stringify({...data}),
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    const rest = await res.json();
    if (onSuccess) {
        onSuccess(rest);
    }
    return rest;
};


